<template>
  <div class="student">
    <div class="studens_header">
      <h1>Студенты</h1>
      <div class="students_header-btn">
        <v-btn :loading="studyFacultiesLoading" @click.prevent="assignTask()" color="outline-primary">
            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M6 1C6 0.447715 5.55228 0 5 0C4.44772 0 4 0.447715 4 1V4L1 4C0.447715 4 0 4.44771 0 5C0 5.55228 0.447715 6 1 6H4V9C4 9.55229 4.44772 10 5 10C5.55229 10 6 9.55229 6 9V6H9C9.55228 6 10 5.55228 10 5C10 4.44772 9.55229 4 9 4L6 4V1Z" fill="#4854FE"/>
            </svg>
            Назначить задание
        </v-btn>
      </div>
    </div>
    <div class="grade_item-container">
            <h2 class="grade_item-name">Фильтр</h2>
            <v-form class="grade_item-filter-wrap">
                <v-row style="width: 90%;">
                    <v-col cols="12" md="4" lg="4" class="filter-item">
                        <h3 class="filter-item-name">Факультет</h3>
                        <v-autocomplete
                            label=""
                            :items="faculties.list"
                            variant="outlined"
                            hide-details=""
                            item-value="id"
                            item-text="name"
                            class="filter-item-combobox"
                            v-model="faculties.selected"
                            :disabled="faculties.list === null"
                            :loading="faculties.list === null"
                            :search-input.sync="faculties.searchInput"
                            @change="filterStudent"
                            placeholder="Все"
                            clearable
                            multiple
                        >
                        <template v-slot:selection="{ item, index }">
                                <span style="width: 80%;" v-if="index === 0" >{{ item.name }}</span>

                                <span v-if="index === 1" class="grey--text text-caption">
                                    +{{ faculties.selected.length - 1 }} еще выбранных(й)
                                </span>
                        </template>
                    </v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="4" lg="2" class="filter-item">
                        <h3 class="filter-item-name">Курс</h3>
                        <v-autocomplete
                            label=""
                            :items="studyCourse.list"
                            variant="outlined"
                            hide-details=""
                            item-text="name"
                            item-value="id"
                            class="filter-item-combobox"
                            v-model="studyCourse.selected"
                            :disabled="studyCourse.selected === null"
                            :loading="studyCourse.list === null"
                            :search-input.sync="studyCourse.searchInput"
                            @change="filterStudent"
                            placeholder="Все"
                            clearable
                            multiple
                        >
                        <template v-slot:selection="{ item, index }">
                            <span v-if="index === 0" >{{ item.name }}</span>

                                <span v-if="index === 1" class="grey--text text-caption">
                                    +{{ studyCourse.selected.length - 1 }} еще выбранных(й)
                                </span>
                            </template>
                    </v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="4" lg="2" class="filter-item">
                        <h3 class="filter-item-name">Группа</h3>
                        <v-autocomplete
                            label=""
                            hide-details
                            :items="groups.list"
                            item-value="id"
                            item-text="name"
                            variant="outlined"
                            class="filter-item-combobox"
                            v-model="groups.selected"
                            :disabled="groups.list === null"
                            :loading="groups.list === null"
                            :search-input.sync="groups.searchInput"
                            @change="filterStudent"
                            placeholder="Все"
                            clearable
                            multiple
                        >
                        <template v-slot:selection="{ item, index }">
                            <span v-if="index === 0" >{{ item.name }}</span>

                                <span v-if="index === 1" class="grey--text text-caption">
                                    +{{ groups.selected.length - 1 }} еще выбранных(й)
                                </span>
                            </template>
                    </v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="4" lg="4" class="filter-item">
                        <h3 class="filter-item-name">ФИО студента</h3>
                        <v-autocomplete
                            label=""
                            hide-details
                            return-object
                            :items="studentsList.list"
                            item-value="fio"
                            item-text="fio"
                            variant="outlined"
                            class="filter-item-combobox"
                            v-model="studentsList.selected"
                            :disabled="studentsList.list === null"
                            :loading="studentsList.list === null"
                            :search-input.sync="studentsList.searchInput"
                            @change="filterStudent"
                            placeholder="Все"
                            clearable
                            multiple
                        >
                        <template v-slot:selection="{ item, index }">
                                <span v-if="index === 0" >{{ item.fio }}</span>

                                <span v-if="index === 1" class="grey--text text-caption">
                                    +{{ studentsList.selected.length - 1 }} еще выбранных(й)
                                </span>
                            </template>
                    </v-autocomplete>
                    </v-col>
                </v-row>
            </v-form>
        </div>
    <div class="students_lists">
      <div v-for="(student, index) in students.list" :key="index" class="students_lists-item">
        <div class="students_lists-item-header">
          <img class="students-photo" :src="getPhotoUrl(student)" />
          <div class="students-name">{{ student.fio }}</div>
        </div>
        <div class="students_lists-item-info">
          <p class="txt-left">Курс</p>
          <p class="txt-right">{{ student.studyCourseName }}</p>
        </div>
        <div class="students_lists-item-info">
          <p class="txt-left">Группа</p>
          <p class="txt-right">{{ student.groupName }}</p>
        </div>
        <div class="students_lists-item-org">
          <p class="txt-left">Факультет</p>
          <p class="txt-right">{{ student.facultyName }}</p>
        </div>
        <div class="students_lists-item-org">
          <p class="txt-left">Организация</p>
          <p class="txt-right">{{ student.organizationName }}</p>
        </div>
        <div class="students_lists-item-info">
          <p class="txt-left ">
            Количество пройденных и назначенных заданий:
          </p>
          <p class="txt-right">
            <span class="first">{{ student.completeCount }}</span>/<span class="second">{{ student.activateCount }}</span>
          </p>
        </div>
        <a v-if="student.completeCount || student.activateCount " :href="`/teacher/students/${student.id}`" class="students_lists-btn">
          Посмотреть задания
        </a>
        <a v-else class="students_lists-btn-disable">
          Посмотреть задания
        </a>
      </div>
    </div>
    <div class="data-footer">
      <div class="pagination" v-if="params.pageSize != allItemsSize">
        <span>Cтраница:</span>
        <div class="pagination_prev" @click.prevent="paginationPrev">
          <svg width="8" height="16" viewBox="0 0 8 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path id="shape" fill-rule="evenodd" clip-rule="evenodd" d="M0.269108 8.64968L6.70064 15.0812L8 13.7818L2.21815 8L8 2.21815L6.70064 0.918787L0.269108 7.35031C-0.0897023 7.70912 -0.0897023 8.29087 0.269108 8.64968Z" fill="#878A91"/>
          </svg>
        </div>
        <div class="pagination_number">
          {{ params.currentPage + 1 }}
        </div>
        <div class="pagination_next" v-if="params.pageSize" @click.prevent="paginationNext">
          <svg xmlns="http://www.w3.org/2000/svg" width="8" height="16" viewBox="0 0 8 16" fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M7.73089 8.64965L1.29936 15.0812L-5.6797e-08 13.7818L5.78185 7.99997L-5.62262e-07 2.21812L1.29936 0.918756L7.73089 7.35028C8.0897 7.70909 8.0897 8.29084 7.73089 8.64965Z" fill="#878A91"/>
          </svg>
        </div>
      </div>
      <div class="select-list">
        <span>Выводить:</span>
        <div class="select-list_drop">
          <v-menu>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="white"
                v-bind="attrs"
                v-on="on"
              >
                <span>{{ params.pageSize != allItemsSize ? params.pageSize : 'Все' }}</span>
                <div class="drop-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.41079 14.5118L3.57745 8.67851L4.75596 7.5L10 12.7441L15.2441 7.5L16.4226 8.67851L10.5893 14.5118C10.2639 14.8373 9.73622 14.8373 9.41079 14.5118Z" fill="black"/>
                  </svg>
                </div>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="(item, index) in pageSizes"
                :key="index"
                @change="updatePageSize(item.size)"
              >
                <v-list-item-title>{{ item.name }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </div>
    </div>

    <v-dialog persistent v-model="assignDialog.show" max-width="1000">
        <AssignDialog
            ref="assignDialog"
            :faculties="faculties.list"
            @success="loadStudents"
            @snackbar="(x) => snackbar = x"
            @close="assignDialog.show = false"
        />
    </v-dialog>

    <TimeoutSnackbar :options="snackbar" />
  </div>
</template>

<script>
import debounce from 'lodash.debounce';
import { mapGetters } from 'vuex';
import AssignDialog from './AssignDialog.vue';
import TimeoutSnackbar from '@/components/TimeoutSnackbar.vue';
import './index.scss';

const AllItemsSize = 10000;

export default {
    components: { AssignDialog, TimeoutSnackbar },
    data() {
        return {
            studyCourse: {
            list: [],
            selected: [],
            searchInput: ''
        },
        faculties: {
            list: [],
            selected: [],
            searchInput: ''
        },
        groups: {
            list: null,
            selected: [],
            searchInput: ''
        },
        students: {
            list: null,
            selected: [],
            searchInput: ''
        },
        params: {
            filters: [],
            sortOption: {
                fieldName: 'groupName',
                sortType: 2
            },
            pageSize: 10,
            currentPage: 0,
            useANDoperator: true,
            columns: []
        },
        paramsList: {
            filters: [],
            sortOption: {
                fieldName: 'groupName',
                sortType: 2
            },
            pageSize: 9999,
            currentPage: 0,
            useANDoperator: true,
            columns: []
        },
        studentsList: {
          list: [],
          selected: [],
          searchInput: ''
        },
        studyFacultiesLoading: true,
        studyCourseLoading: true,
        totalCount: 0,
        allItemsSize: AllItemsSize,
        pageSizes: [
            { name: '5', size: 5 },
            { name: '10', size: 10 },
            { name: '15', size: 15 },
            { name: 'Все', size: AllItemsSize }
        ],
        assignDialog: {
            show: false
        },
        snackbar: {
            show: false,
            text: null,
            color: null,
            timeout: -1
        }
        }
    },
    computed: {
        ...mapGetters({
        apiUrl: 'apiUrl',
        apiImg: 'apiImg'
        })
    },
    methods: {
      loadStudentsList() {
            this.$http.post(`${this.apiUrl}Student/GetAll`,this.paramsList)
                .then((result) => {
                this.studentsList.list = result.data.data;
                this.totalCount = this.params.pageSize ? Math.ceil(result.data.totalRecords / this.params.pageSize) : 1;
            });
        },
        loadStudents() {
            this.$http.post(`${this.apiUrl}Student/GetAll`, this.params)
                .then((result) => {
                this.students.list = result.data.data;
                this.totalCount = this.params.pageSize ? Math.ceil(result.data.totalRecords / this.params.pageSize) : 1;
            });
        },
        filterStudent(){
          this.params.filters = [];
          this.paramsList.filters = [];

            if (this.faculties.selected.length > 0) {
                this.getCourse(this.faculties.selected);
                this.params.filters.push({
                    fieldName: 'facultyId',
                    filterType: 9,
                    filterValueType: 1,
                    values: this.faculties.selected
                });
                this.paramsList.filters.push({
                    fieldName: 'facultyId',
                    filterType: 9,
                    filterValueType: 1,
                    values: this.faculties.selected
                });
                this.studyCourse.searchInput = '';
            }
            else{
                this.getCourse();
            }
            if (this.studyCourse.selected.length > 0) {
                this.getGroups(this.faculties.selected, this.studyCourse.selected);
                this.params.filters.push({
                    fieldName: 'studyCourseId',
                    filterType: 9,
                    filterValueType: 1,
                    values: this.studyCourse.selected
                });
                this.paramsList.filters.push({
                    fieldName: 'studyCourseId',
                    filterType: 9,
                    filterValueType: 1,
                    values: this.studyCourse.selected
                });

                this.studyCourse.searchInput = '';
            }
            else{
                this.getGroups();
            }
            if (this.groups.selected.length > 0) {
              this.params.filters.push({
                    fieldName: 'groupId',
                    filterType: 9,
                    filterValueType: 1,
                    values: this.groups.selected
                });
                this.paramsList.filters.push({
                    fieldName: 'groupId',
                    filterType: 9,
                    filterValueType: 1,
                    values: this.groups.selected
                });

                this.groups.searchInput = '';
            }
            if (this.studentsList.selected.length > 0) {
                for (let i = 0; i < this.studentsList.selected.length; i++) {
                  this.params.filters.push({
                    fieldName: 'fio',
                    filterType: 2,
                    filterValueType: 1,
                    value1: this.studentsList.selected[i].fio
                });
                this.paramsList.filters.push({
                    fieldName: 'fio',
                    filterType: 2,
                    filterValueType: 1,
                    value1: this.studentsList.selected[i].fio
                });

                }


                this.students.searchInput = '';
            }

            this.loadStudents()
            this.loadStudentsList()
        },
        sortArray(array, name) {
            return array.sort((a, b) => {
                if (a[name] < b[name]) {
                    return -1;
                }

                if (a[name] > b[name]) {
                    return 1;
                }

                return 0;
            })
        },
        getPhotoUrl(student) {
        if (student.logoUrl) {
            return `${this.apiImg}${student.logoUrl}`;
        }

        if (student.gender === 1) {
            return require('@/assets/img/avatar-boy.png');
        }

        if (student.gender === 2) {
            return require('@/assets/img/avatar-girl.png');
        }

        return require('@/assets/img/default-profile-image.png');
        },
        paginationPrev() {
        this.params.currentPage = this.params.currentPage == 0 ? this.params.currentPage : --this.params.currentPage;
        this.loadStudents();
        },
        paginationNext() {
        this.params.currentPage = this.params.currentPage == (this.totalCount - 1) ? this.params.currentPage : ++this.params.currentPage;
        this.loadStudents();
        },
        updatePageSize(size) {
        this.params.currentPage = 0;
        this.params.pageSize = size;
        this.loadStudents();
        },
        assignTask() {
        this.assignDialog.show = true;
        //   this.$refs.assignDialog.reset();
        },
        getCourse(arrayIds) {
         let queryParamsFaculties = '';
         if (arrayIds != null) {
            for (let i = 0; i < arrayIds.length; i++) {
                queryParamsFaculties += `${i === 0 ? '?' : '&'}`;
                queryParamsFaculties += `facultyIds=${arrayIds[i]}`
            }
         }
            this.$http.get(`${this.apiUrl}SprOrganizationUnit/GetStudyCourses${queryParamsFaculties ? queryParamsFaculties : ''}`)
                .then((response) => {
                    this.studyCourse.list = response.data;
                    this.loadingListCourse = false;
                });
        },
        getGroups(facultyIds, courseIds) {
         let queryParamsFaculties = '';
         let queryParamsCourse = '';

         if (facultyIds != null) {
            for (let i = 0; i < facultyIds.length; i++) {
                queryParamsFaculties += `${i === 0 ? '?' : '&'}`;
                queryParamsFaculties += `facultyIds=${facultyIds[i]}`
            }
         }
         if (courseIds != null) {
            for (let i = 0; i < courseIds.length; i++) {
                queryParamsCourse += `${facultyIds.length === 0 && i === 0 ? '?' : '&'}`;
                queryParamsCourse += `courseIds=${courseIds[i]}`
            }
         }
            this.$http.get(`${this.apiUrl}SprOrganizationUnit/GetStudyGroups${queryParamsFaculties ? queryParamsFaculties : ''}${queryParamsCourse ? queryParamsCourse : ''}`)
                .then((response) => {
                    this.groups.list = response.data;
                    if(facultyIds != null && courseIds!=null && this.groups.selected != 0){
                      this.$http.post(`${this.apiUrl}Student/GetAll`, this.params)
            .then((response) => {
                this.students.list = response.data.data;
                this.loadStudentsList()
            });
                    }
                });
        },
        getFacultiesByCurrentUser() {
            this.$http.get(`${this.apiUrl}SprOrganizationUnit/GetFacultiesByCurrentUser`)
                .then((response) => {
                    this.faculties.list = response.data;
                    this.studyFacultiesLoading = false;
                });
        }
    },
    created() {
        this.getCourse();
        this.getGroups();
        this.getFacultiesByCurrentUser();
        this.loadStudents();
        this.loadStudentsList()
    }
}
</script>
<style scoped lang="scss">
.grade_item-filter-wrap {
    align-self: stretch;
    .filter-item {
        align-self: end;
        .filter-item-name {
            margin-bottom: 4px;
            color: #2B2D33;
            font-family: Inter;
            font-size: 14px;
            font-style: normal;
            font-weight: 600;
            line-height: 26px; /* 185.714% */
        }
        .filter-item-combobox {
            width: 100%;
            font-family: Inter;
            font-size: 14px;
            font-style: normal;
            font-weight: 500;
            line-height: 22px; /* 157.143% */
            border-radius: 8px;
            border: 1px solid #CACDD3;
        }
        .filter-item-date {
            width: 100%;
            display: flex;
            gap: 10px;
            span {
                margin-top: 10px;
                color: #AAAEB7;
                font-family: Inter;
                font-size: 14px;
                font-style: normal;
                font-weight: 400;
                line-height: 22px;
            }
        }
    }
}
</style>

